import { QueryLazyOptions } from '@apollo/client';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { up } from 'styled-breakpoints';
import styled from 'styled-components';

import ContentContainer from '@rebound/design-system/components/ContentContainer';
import { Return } from '@rebound/shared-models/return/return.model';

import TrackReturnForm from './TrackReturnForm';

type HeroSectionProps = {
  findReturnByTracking: (
    options?: QueryLazyOptions<Record<string, any>> | undefined,
  ) => void;
  trackReturnData?: Return[];
  scheme: string;
};

const HeroSection = ({
  findReturnByTracking,
  trackReturnData,
  scheme,
}: HeroSectionProps) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <ContentContainer>
        <Title>{t('trackReturnPage.heroTitle') as string}</Title>
        <Description>
          {t('trackReturnPage.heroDescription') as string}
        </Description>
        <TrackReturnForm
          findReturnByTracking={findReturnByTracking}
          trackReturnData={trackReturnData}
          scheme={scheme}
        />
      </ContentContainer>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background-color: ${(props) => props.theme.colors.grayLight};
  padding: 24px 20px;
  color: ${(props) => props.theme.colors.grayDark4};

  ${up('md')} {
    padding: 24px 10px;
  }

  ${up('lg')} {
    padding: 24px 240px;
  }
`;

const Title = styled.h1`
  font-weight: 800;
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 12px;
`;

const Description = styled.p`
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 24px;
  max-width: 550px;

  ${up('lg')} {
    margin-bottom: 34px;
  }
`;

export default HeroSection;
